import { OnInit } from "@angular/core";
import { Component, Input } from "@angular/core";
import { AgentInfo } from "@app/core/models/agent";

@Component({
  selector: "main-header",
  templateUrl: "./main-layout-header.template.html"
})
export class MainLayoutHeaderComponent {
  //public image_src: string = "./assets/images/Wellness white.png";
  @Input() agent: AgentInfo;
  @Input() image_src = "../../../../../assets/images/wellnex_pink.png";
  @Input() backgroundColor: any = '#4D4D4D';
  @Input() textColor;
  @Input() buttonTextColor;
  href: string;
  constructor() {
    let initialHref = window.sessionStorage.getItem('initialHref');    
    if (initialHref == null || initialHref == '') {
      initialHref = window.location.href;      
    } 
    window.sessionStorage.setItem('initialHref', initialHref);   

    this.href = initialHref;
    console.log('href', this.href);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/layout/main-layout-header/main-layout-header.component.ts